import * as React from 'react';

export function Loading() {
  return (
    <div>loading...</div>
  );
}
